/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Plan_StarterInputs */

const en_signup_plan_starter = /** @type {(inputs: Signup_Plan_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter`)
};

const fr_signup_plan_starter = /** @type {(inputs: Signup_Plan_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débutant`)
};

const de_signup_plan_starter = /** @type {(inputs: Signup_Plan_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlasser`)
};

const it_signup_plan_starter = /** @type {(inputs: Signup_Plan_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antipasto`)
};

const ru_signup_plan_starter = /** @type {(inputs: Signup_Plan_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стартер`)
};

const es_signup_plan_starter = /** @type {(inputs: Signup_Plan_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor de arranque`)
};

const zh_cn2_signup_plan_starter = /** @type {(inputs: Signup_Plan_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起动机`)
};

const ja_signup_plan_starter = /** @type {(inputs: Signup_Plan_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スターター`)
};

const hi_signup_plan_starter = /** @type {(inputs: Signup_Plan_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टार्टर`)
};

const pt_pt2_signup_plan_starter = /** @type {(inputs: Signup_Plan_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciante`)
};

/**
* | output |
* | --- |
* | "Starter" |
*
* @param {Signup_Plan_StarterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_plan_starter = /** @type {((inputs?: Signup_Plan_StarterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Plan_StarterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_plan_starter(inputs)
	if (locale === "de") return de_signup_plan_starter(inputs)
	if (locale === "it") return it_signup_plan_starter(inputs)
	if (locale === "ru") return ru_signup_plan_starter(inputs)
	if (locale === "es") return es_signup_plan_starter(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_plan_starter(inputs)
	if (locale === "ja") return ja_signup_plan_starter(inputs)
	if (locale === "hi") return hi_signup_plan_starter(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_plan_starter(inputs)
	return en_signup_plan_starter(inputs)
});